export default {
  strict: true,
  namespaced: true,
  state: {
    saving: false,
    serviceTypes: {
      list: [],
      isLoading: false,
      isClickable: false,
      enableList: [],
      disableList: []
    },
    global: {
      pickupTypes: [],
      pickupTypesCharter: []
    }
  },
  mutations: {
    clearServiceTypes (state) { state.serviceTypes.list = [] },
    addServiceTypes (state, value) { state.serviceTypes.list.push(value) },
    updateServiceTypeData (state, data) {
      let index = state.serviceTypes.list.findIndex(x => x.id === data.id)
      if (index > -1) {
        state.serviceTypes.list[index] = data
      }
    },
    updateServiceTypeField (state, data) {
      let index = state.serviceTypes.list.findIndex(x => x.id === data.id)
      if (index > -1) {
        state.serviceTypes.list[index][data.type][data.field] = data.value
      }
    },
    updateServiceTypeEnable (state, data) {
      let index = state.serviceTypes.list.findIndex(x => x.id === data.id)
      if (index > -1) {
        state.serviceTypes.list[index][data.field] = data.value
      }
    },
    updateServiceTypePickupType (state, data) {
      let index = state.serviceTypes.list.findIndex(x => x.id === data.id)
      if (index > -1) {
        if (!state.serviceTypes.list[index].pickupTypes[data.type]) {
          state.serviceTypes.list[index].pickupTypes[data.type] = {
            name: data.type
          }
        }
        state.serviceTypes.list[index].pickupTypes[data.type][data.field] = data.value
      }
    },
    setSaving (state, value) { state.saving = value },
    setServiceTypesIsloading (state, value) { state.serviceTypes.isLoading = value },
    setServiceTypesIsClickable (state, value) { state.serviceTypes.isClickable = value },
    updateEnableList (state, value) {
      let index = state.serviceTypes.enableList.indexOf(value)
      if (index > -1) {
        state.serviceTypes.enableList.splice(index, 1)
      } else {
        state.serviceTypes.enableList.push(value)
        let disableIndex = state.serviceTypes.disableList.indexOf(value)
        if (disableIndex > -1) {
          state.serviceTypes.disableList.splice(disableIndex, 1)
        }
      }
    },
    updateDisableList (state, value) {
      let index = state.serviceTypes.disableList.indexOf(value)
      if (index > -1) {
        state.serviceTypes.disableList.splice(index, 1)
      } else {
        state.serviceTypes.disableList.push(value)
        let enableIndex = state.serviceTypes.enableList.indexOf(value)
        if (enableIndex > -1) {
          state.serviceTypes.enableList.splice(enableIndex, 1)
        }
      }
    },
    resetEnableList (state) {
      state.serviceTypes.enableList = []
      state.serviceTypes.disableList = []
    },
    setGlobalData (state, data) {
      for (let field in data) {
        state.global[field] = data[field]
      }
    },
    updateGlobalPickupTypeData (state, data) {
      state.global.pickupTypes[data.index].pickupTypes[data.type].enabled = data.value
    },
    updateGlobalPickupTypeCharterData (state, data) {
      state.global.pickupTypesCharter[data.index].pickupTypes[data.type].enabled = data.value
    }
  },
  sharedMutations: []
}


// WEBPACK FOOTER //
// ./src/store/pricing/service-types.js